@if (!gridLayout) {
  <div class="w-full max-w-full mx-auto sm:max-w-[80%]">
    <div class="mb-6 text-left">
      <header class="mb-6 ">
        <div class="text-3xl font-bold ">{{ title }}</div>
        @if (subtitle != '') {
          <div class="mt-2 leading-tight text-secondary">{{ subtitle }}</div>
        }
      </header>
      <div class="flex flex-col w-full gap-4">
        @for (investmentStrategy of displayInvestmentStrategies; track investmentStrategy) {
          <bp-image-info-card
            [image]="investmentStrategy.iconUrl"
            [imageAlt]="investmentStrategy.title"
            [responsiveLayout]="'col'"
            [roundedImage]="false"
            (click)="next.emit(investmentStrategy)"
            id="cg-new-investmentStrategySelection-{{ investmentStrategy.code }}-btn-continue"
        [attr.data-cy]="
          'cg-new-investmentStrategySelection-' + investmentStrategy.code + '-btn-continue'
        "
            >
            <ng-container title>
              <div class="flex flex-row items-center gap-3">
                <span bp-title-card>
                  {{ investmentStrategy.title }}
                </span>
                @if (investmentStrategy.isRecommended) {
                  <span bp-badge="primary">Más elegido</span>
                }
                @if (getPortfoliosFilteredByInvestmentStrategy(investmentStrategy); as portfolios) {
                  @if (
                    portfolios.length === 1 &&
                    portfolios[0].estimatedProfitability &&
                    portfolios[0].estimatedProfitability !== ''
                    ) {
                    <span
                      class="px-2.5 py-0 text-sm text-white rounded-full bg-primary"
                      >{{ portfolios[0].estimatedProfitability }}</span
                      >
                    }
                  }
                </div>
              </ng-container>
              <ng-container body>
                <span bp-text-values-card>
                  {{ investmentStrategy.description }}
                </span>
                @if (investmentStrategy.recommendedFor) {
                  <div class="pt-2">
                    <span bp-tag>Recomendado para</span>
                    <p class="flex-1 pt-1 text-sm text-secondary">
                      {{ investmentStrategy.recommendedFor }}
                    </p>
                  </div>
                }
              </ng-container>
            </bp-image-info-card>
          }
        </div>
      </div>
    </div>
  }

  @if (gridLayout) {
    <div class="w-full max-w-full mx-auto ">
      <div class="mb-6 text-left">
        <header class="mb-6 ">
          <div class="text-3xl font-bold ">{{ title }}</div>
          <div class="mt-2 leading-tight text-secondary">
            Cada una de las estrategias tiene un objetivo distinto, pero todas ellas pueden luego ser
            implementadas para distintos niveles de riesgo.
          </div>
        </header>
        <div class="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3">
          @for (investmentStrategy of displayInvestmentStrategies; track investmentStrategy) {
            <bp-image-info-card
              layout="col"
              [arrow]="false"
              [responsiveLayout]="'col'"
              (click)="next.emit(investmentStrategy)"
              >
              <ng-container title>
                <div class="flex flex-row items-center gap-3">
                  <span bp-title-card>
                    {{ investmentStrategy.title }}
                  </span>
                  <!-- <ng-container
                  *ngIf="getPortfoliosFilteredByInvestmentStrategy(investmentStrategy) as portfolios"
                  >
                  <span
                    class="px-2.5 py-0 text-sm text-white rounded-full bg-primary"
                *ngIf="
                  portfolios.length === 1 &&
                  portfolios[0].estimatedProfitability &&
                  portfolios[0].estimatedProfitability !== ''
                "
                    >{{ portfolios[0].estimatedProfitability }}</span
                    >
                  </ng-container> -->
                </div>
              </ng-container>
              <ng-container body>
                <div class="flex flex-col h-full gap-3 mt-2">
                  <span class="flex-grow h-full">
                    {{ investmentStrategy.description }}
                  </span>
                  <mat-divider></mat-divider>
                  <div bp-title-card>Características</div>
                  @for (feature of investmentStrategy.features; track feature) {
                    <p class="flex gap-2">
                      <span class="mt-1">
                        <i class="fas fa-check text-primary"></i>
                      </span>
                      <span class="pr-0 ">
                        {{ feature }}
                      </span>
                    </p>
                  }
                  <button mat-stroked-button color="primary">
                    Elegir estrategia
                  </button>
                </div>
              </ng-container>
            </bp-image-info-card>
          }
        </div>
      </div>
    </div>
  }
